import type { Point } from './geometry';
import { placeInRegion, type PlacementResult } from './placement';
import type { RegionDefinition } from './region-definition';

export function placeNpcInRegion(
  region: RegionDefinition,
  npcId: string,
  occupied: readonly Point[],
): PlacementResult {
  return placeInRegion({
    region,
    seed: `${region.id}:npc:${npcId}`,
    zoneKinds: ['npc'],
    radius: 18,
    occupied,
    minSeparation: 48,
    avoidEntrancesBy: 48,
  });
}
